import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent
} from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { TreeView, TreeItem } from '@mui/lab';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from '@mui/material';
import { ExpandLess } from '@mui/icons-material';


// Fix Leaflet's marker icon path issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// Dummy data
const locationData = [
  {
    country: 'India',
    cities: [
      {
        city: 'Delhi',
        coordinates: [28.6139, 77.209],
        devices: [
          { id: 1, name: 'Device A', coordinates: [28.6139, 77.209] },
          { id: 2, name: 'Device B', coordinates: [28.6149, 77.2095] },
        ],
      },
      {
        city: 'Mumbai',
        coordinates: [19.076, 72.8777],
        devices: [
          { id: 3, name: 'Device C', coordinates: [19.076, 72.8777] },
        ],
      },
    ],
  },
  {
    country: 'USA',
    cities: [
      {
        city: 'New York',
        coordinates: [40.7128, -74.006],
        devices: [
          { id: 4, name: 'Device D', coordinates: [40.7128, -74.006] },
        ],
      },
    ],
  },
];


const DeviceLocator = () => {
  const [selectedDevices, setSelectedDevices] = useState([]);

  const [openCountries, setOpenCountries] = useState({});

  const handleCountryClick = (countryName) => {
    setOpenCountries((prev) => ({
      ...prev,
      [countryName]: !prev[countryName],
    }));
  };

  const handleCityClick = (devices) => {
    setSelectedDevices(devices);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        Device Locator
      </Typography>
      <Typography variant="body2" sx={{ color: 'gray', mb: 1 }}>
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>

      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          <Box sx={{ display: 'flex', height: '500px' }}>
            {/* Tree View (30%) */}
            <Box sx={{ width: '30%', overflowY: 'auto', pr: 2 }}>
              <List component="nav">
                {locationData.map((country) => (
                  <React.Fragment key={country.country}>
                    <ListItemButton onClick={() => handleCountryClick(country.country)}>
                      <ListItemText primary={country.country} />
                      {openCountries[country.country] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openCountries[country.country]} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {country.cities.map((city) => (
                          <ListItemButton
                            key={city.city}
                            sx={{ pl: 4 }}
                            onClick={() => handleCityClick(city.devices)}
                          >
                            <ListItemText primary={city.city} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
              </List>
            </Box>


            {/* Map (70%) */}
            {/* <Box sx={{ width: '70%' }}>
              <MapContainer
                center={[20.5937, 78.9629]} // India center
                zoom={4}
                style={{ height: '100%', width: '100%' }}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {selectedDevices.map((device) => (
                  <Marker key={device.id} position={device.coordinates}>
                    <Popup>{device.name}</Popup>
                  </Marker>
                ))}
              </MapContainer>
            </Box> */}
            <Box sx={{ width: '70%' }}>
              <MapContainer
                center={[20.5937, 78.9629]} // India center
                zoom={4}
                style={{ height: '100%', width: '100%' }}
              >
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                />
                {selectedDevices.map((device) => (
                  <Marker key={device.id} position={device.coordinates}>
                    <Popup>{device.name}</Popup>
                  </Marker>
                ))}
              </MapContainer>
            </Box>

          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DeviceLocator;
